import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  noDocumentRoot: {
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'auto 1fr'
  },

  breadcrumbsContainer: {
    marginTop: 'calc(1.5rem + 14px)',
    marginLeft: 38
  },

  noDocumentContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexFlow: 'column'
  },

  icon: {
    marginBottom: '24px'
  },

  title: {
    marginBottom: '16px',
    padding: ({ isSmall }) => (isSmall ? '0 1rem' : '0'),
    fontSize: theme.size.base,
    textAlign: 'center',
    color: '#1F1F1F'
  },

  subtitle: {
    marginBottom: '16px',
    padding: ({ isSmall }) => (isSmall ? '0 1rem' : '0'),
    fontSize: theme.size.sm,
    textAlign: 'center',
    color: '#1F1F1F'
  },

  buttonBar: {
    display: 'flex',
    alignItems: 'center',

    '& > button': {
      width: 'auto',
      height: '28px',
      fontSize: theme.size.sm
    },

    '& > :not(:last-child)': {
      marginRight: '8px'
    }
  }
}))

export default useStyles
